angular.module('internal.events',[])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('internal.events', {
            url: '/events',
            views: {
                'content': {
                    templateUrl: 'js/internal/events/events.view.html',
                    controller:'EventsCtrl'
                }
            }
        });
    }]);